<template>
  <div>
    <h1 class="title is-6 has-text-centered has-text-weight-bold">{{ title }}</h1>
    <div class="chart" ref="chart"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { currency, wholeNumber, dateShort } from '@/filters'

google.charts.load('current', {'packages':['corechart']})

export default {
  props: {
    title: {
      required: true
    },
    column: {
      required: true
    },
  },
  computed: {
    ...mapGetters([
      'orderItemsPlaced',
    ]),
    chartAnnotations() {
      return [...new Set(this.orderItemsPlaced.map((item) => item[this.column]).filter(n => n))].sort((a, b) => parseFloat(a.replace('CC', '')) - parseFloat(b.replace('CC', '')))
    },
    chartData() {
      let data = []
      this.chartAnnotations.forEach((annotation) => {
        data.push(this.orderItemsPlaced.filter((item) => item[this.column] === annotation).reduce((carry, item) => carry += item.quantity, 0))
      })
      console.log(data)
      return data
    },
  },
  methods: {
    drawChart () {
      const options = {
        backgroundColor: '#ffffff',
        // colors: [
        //   '#01579B',
        //   '#0277BD',
        //   '#0288D1',
        //   '#039BE5',
        //   '#03A9F4',
        //   '#29B6F6',
        //   '#4FC3F7',
        //   '#81D4FA',
        //   '#B3E5FC',
        //   '#E1F5FE',
        // ],
        title: '',
        fontName: 'Nunito',
        legend: {
          position: 'bottom',
          maxLines: 5,
          textStyle: {
            fontName: 'Nunito'
          }
        },
        hAxis: {
          viewWindowMode: 'pretty',
          minValue: 0,
          ticks: [0, .25, .50, .75, 1]
        },
        height: 225,
        width: '75%',
        seriesType: 'bars',
        bar: {
          groupWidth: '50%'
        },
        isStacked: 'percent',
      }

      const dataTable = google.visualization.arrayToDataTable([
        ['Timeframe', ...this.chartAnnotations, { role: 'annotation' }],
        ['', ...this.chartData, ''],
      ])

      const chart = new google.visualization.BarChart(this.$refs.chart)
      chart.draw(dataTable, options)
    }
  },
  filters: {
    currency,
    wholeNumber,
    dateShort
  },
  mounted () {
    console.log(this.chartAnnotations)
    google.charts.setOnLoadCallback(() => this.drawChart())    
  }
}
</script>
